module.exports = __webpack_public_path__ + "img/b8e95c9.jpg";